module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/border-top.8cfbd0f9.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/border-top.png
// module id = 2748
// module chunks = 11